import { plainToClass } from 'class-transformer'
import { forOwn, isArray, isObject } from 'lodash'

export const paginatedTransform = (Model: any) => {
  return (data: any) => {
    const response = data
    if (
      !response ||
      !response.results ||
      !response.results.length ||
      response.results[0] instanceof Model
    ) {
      return response
    }
    response.results = plainToClass(Model, response.results)
    return response
  }
}

export const rawTransform = (Model: any) => {
  return (data: any) => {
    if (data.length && data[0] instanceof Model) {
      return data
    }
    if (data.length === undefined && data instanceof Model) {
      return data
    }
    return plainToClass(Model, data)
  }
}

export const withCallback = <T extends Array<any>, U>(
  fn: (...args: T) => Promise<U>,
  onResponse?: (response: U) => void
) => {
  return async (...args: T): Promise<U> => {
    const response = await fn(...args)
    if (onResponse) {
      onResponse(response)
    }
    return response
  }
}

export const jsToFormData = (obj: any) => {
  const formData = new FormData()

  const recurse = (obj: any, path: string) => {
    if (isArray(obj)) {
      obj.map((item, index) => recurse(item, `${path}[${index}]`))
    } else if (isObject(obj) && !(obj instanceof File)) {
      forOwn(obj, (value, key) => {
        recurse(value, `${path}${path !== '' && !path.endsWith(']') ? '.' : ''}${key}`)
      })
    } else {
      formData.set(path, obj)
    }
  }
  recurse(obj, '')

  return formData
}
